// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41bcf493","239":"139ed535","732":"554c0d1f"}[chunkId] + ".chunk.js";
};